import { AppSidebar } from '@/components/AppSidebar'
import { Header } from '@/components/Header'
import { SidebarInset, SidebarProvider } from '@/components/ui/sidebar'
import { Outlet } from 'react-router-dom'

export function MainLayout() {
  return (
    <div data-testid="authenticated-layout">
      <SidebarProvider>
        <AppSidebar />

        <SidebarInset className="min-w-0 overflow-x-hidden">
          <Header />
          <main className="min-w-0 flex-1 overflow-y-auto overflow-x-hidden p-4 md:p-6">
            <Outlet />
          </main>
        </SidebarInset>
      </SidebarProvider>
    </div>
  )
}
